import type { TranslationCatalog } from '../../shared/i18n';

// Stable source labels also localize metadata already loaded before a language switch.
export const accountFieldLabels: Record<string,string> = {
  CARI_KOD:'Nummer',UNVAN1:'Name 1',UNVAN2:'Name 2',ADRES1:'Straße',ADRES2:'Adresse 2',IL:'Ort',ILCE:'Ortsteil',ULKE:'Land',ULKE_KOD:'Ländercode',POSTAKODU:'PLZ',TEL1:'Telefon 1',TEL2:'Telefon 2',FAKS:'Fax',MOBIL1:'Mobil 1',MOBIL2:'Mobil 2',EMAIL:'E-Mail',URL:'Internet',GRUP:'Gruppe',VADE_GUN:'Zahlungsziel',TESLIMAT:'Lieferbedingung',ISKONTO_ORAN:'Rabatt %',ALT_ISKONTO_ORAN:'Zusatzrabatt %',SF:'Preisliste',RISK:'Kreditlimit',BOLGE:'Gebiet',VD:'Finanzamt',VN:'Steuernummer',IBAN:'IBAN',MUHASEBE_KOD:'Buchhaltung',UYARI_NOTU:'Warnhinweis',BELGE_NOTU:'Belegnotiz',AP:'Status',
};

export const translations: TranslationCatalog = {
  'Kunden':{tr:'Müşteriler',en:'Customers'},
  'Lieferanten':{tr:'Tedarikçiler',en:'Suppliers'},
  'Kontokarte':{tr:'Cari hesap kartı',en:'Account card'},
  'Kundenkonto':{tr:'Müşteri hesabı',en:'Customer account'},
  'Lieferantenkonto':{tr:'Tedarikçi hesabı',en:'Supplier account'},
  'Kundenkonto history':{tr:'Müşteri hesabı geçmişi',en:'Customer account history'},
  'Lieferantenkonto history':{tr:'Tedarikçi hesabı geçmişi',en:'Supplier account history'},
  'Kontobewegungen':{tr:'Cari hesap hareketleri',en:'Account entries'},
  'Kontobewegungen / Zahlung':{tr:'Hesap hareketleri / Ödeme',en:'Account entries / Payment'},
  'Mahnungen':{tr:'Ödeme hatırlatmaları',en:'Payment reminders'},
  'Nummer':{tr:'Numara',en:'Number'},
  'Name 1':{tr:'Ad 1',en:'Name 1'},
  'Name 2':{tr:'Ad 2',en:'Name 2'},
  'Straße':{tr:'Sokak',en:'Street'},
  'Adresse 2':{tr:'Adres 2',en:'Address 2'},
  'Ort':{tr:'Şehir',en:'City'},
  'Ortsteil':{tr:'İlçe',en:'District'},
  'Land':{tr:'Ülke',en:'Country'},
  'Ländercode':{tr:'Ülke kodu',en:'Country code'},
  'PLZ':{tr:'Posta kodu',en:'Postal code'},
  'Telefon':{tr:'Telefon',en:'Phone'},
  'Telefon 1':{tr:'Telefon 1',en:'Phone 1'},
  'Telefon 2':{tr:'Telefon 2',en:'Phone 2'},
  'Fax':{tr:'Faks',en:'Fax'},
  'Mobil':{tr:'Cep telefonu',en:'Mobile'},
  'Mobil 1':{tr:'Cep telefonu 1',en:'Mobile 1'},
  'Mobil 2':{tr:'Cep telefonu 2',en:'Mobile 2'},
  'E-Mail':{tr:'E-posta',en:'Email'},
  'Internet':{tr:'İnternet',en:'Website'},
  'Gruppe':{tr:'Grup',en:'Group'},
  'Zahlungsziel':{tr:'Ödeme vadesi',en:'Payment terms'},
  'Lieferbedingung':{tr:'Teslimat koşulu',en:'Delivery terms'},
  'Rabatt %':{tr:'İskonto %',en:'Discount %'},
  'Zusatzrabatt %':{tr:'Ek iskonto %',en:'Additional discount %'},
  'Preisliste':{tr:'Fiyat listesi',en:'Price list'},
  'Kreditlimit':{tr:'Kredi limiti',en:'Credit limit'},
  'Gebiet':{tr:'Bölge',en:'Region'},
  'Finanzamt':{tr:'Vergi dairesi',en:'Tax office'},
  'Steuernummer':{tr:'Vergi numarası',en:'Tax number'},
  'IBAN':{tr:'IBAN',en:'IBAN'},
  'Buchhaltung':{tr:'Muhasebe',en:'Accounting'},
  'Warnhinweis':{tr:'Uyarı',en:'Warning'},
  'Belegnotiz':{tr:'Belge notu',en:'Document note'},
  'Status':{tr:'Durum',en:'Status'},
  'Beleg-Nr.':{tr:'Belge no.',en:'Document no.'},
  'Konto':{tr:'Hesap',en:'Account'},
  'Datum':{tr:'Tarih',en:'Date'},
  'Soll':{tr:'Borç',en:'Debit'},
  'Haben':{tr:'Alacak',en:'Credit'},
  'Rest':{tr:'Kalan',en:'Remaining'},
  'Währung':{tr:'Para birimi',en:'Currency'},
  'Bemerkung':{tr:'Not',en:'Note'},
  'Vertreter':{tr:'Temsilci',en:'Representative'},
  'Ergebnis prüfen':{tr:'Sonucu kontrol et',en:'Check result'},
  'Löschergebnis unklar. „Ergebnis prüfen“ wiederholt exakt dieselbe Anfrage.':{tr:'Silme sonucu belirsiz. “Sonucu kontrol et” aynı isteği aynen tekrarlar.',en:'The deletion result is uncertain. “Check result” repeats the exact same request.'},
  'Löschvorgang wird verarbeitet …':{tr:'Silme işlemi sürüyor …',en:'Deleting …'},
  'Änderungen verwerfen?':{tr:'Değişikliklerden vazgeçilsin mi?',en:'Discard changes?'},
  'Adresse':{tr:'Adres',en:'Address'},
  'Konditionen':{tr:'Koşullar',en:'Terms'},
  'Hinweise':{tr:'Notlar',en:'Notes'},
  'Speicherergebnis unklar. Eingaben und Schließen sind gesperrt. „Ergebnis prüfen“ wiederholt exakt dieselbe Anfrage.':{tr:'Kaydetme sonucu belirsiz. Düzenleme ve kapatma kilitlendi. “Sonucu kontrol et” aynı isteği aynen tekrarlar.',en:'The save result is uncertain. Editing and closing are locked. “Check result” repeats the exact same request.'},
  'Aktiv':{tr:'Aktif',en:'Active'},
  'Passiv':{tr:'Pasif',en:'Inactive'},
  'Konto löschen?':{tr:'Hesap silinsin mi?',en:'Delete account?'},
  'Suchen':{tr:'Ara',en:'Search'},
  'Nummer, Name, Ort':{tr:'Numara, ad, şehir',en:'Number, name, city'},
  'Alle':{tr:'Tümü',en:'All'},
  'Saldo':{tr:'Bakiye',en:'Balance'},
  'Alle Salden':{tr:'Tüm bakiyeler',en:'All balances'},
  'Null':{tr:'Sıfır',en:'Zero'},
  'Ändern':{tr:'Düzenle',en:'Edit'},
  'Kopieren':{tr:'Kopyala',en:'Copy'},
  'Drucken ist zurückgestellt':{tr:'Yazdırma sonraki aşamaya bırakıldı',en:'Printing is deferred'},
  'Drucken':{tr:'Yazdır',en:'Print'},
  'Zahlung':{tr:'Ödeme',en:'Payment'},
  'Betrag':{tr:'Tutar',en:'Amount'},
  'Zahlungsart':{tr:'Ödeme şekli',en:'Payment method'},
  'Kasse':{tr:'Kasa',en:'Cash'},
  'Bank':{tr:'Banka',en:'Bank'},
  'Abschreibung':{tr:'Borç silme',en:'Write-off'},
  'Devir':{tr:'Devir',en:'Opening balance'},
  'Belegnummer':{tr:'Belge numarası',en:'Document number'},
  'Beleg':{tr:'Belge',en:'Document'},
  'Zahlung löschen?':{tr:'Ödeme silinsin mi?',en:'Delete payment?'},
  'Kontonummer':{tr:'Hesap numarası',en:'Account number'},
  'Nur offene Posten':{tr:'Yalnızca açık kalemler',en:'Open items only'},
  'Von':{tr:'Başlangıç',en:'From'},
  'Bis':{tr:'Bitiş',en:'To'},
  'Neue Zahlung':{tr:'Yeni ödeme',en:'New payment'},
  'Ändern / Beleg öffnen':{tr:'Düzenle / Belgeyi aç',en:'Edit / Open document'},
  'Zahlung löschen':{tr:'Ödemeyi sil',en:'Delete payment'},
  'Drucken – zurückgestellt':{tr:'Yazdırma – sonraki aşamada',en:'Printing – deferred'},
  'Aktion':{tr:'İşlem',en:'Action'},
  'Geändert':{tr:'Değiştirilme',en:'Changed'},
  'Name':{tr:'Ad',en:'Name'},
  'Belegart':{tr:'Belge türü',en:'Document type'},
  'Kontoart':{tr:'Hesap türü',en:'Account type'},
  'Alter Betrag':{tr:'Önceki tutar',en:'Previous amount'},
  'Altes Konto':{tr:'Önceki hesap',en:'Previous account'},
  'Altes Datum':{tr:'Önceki tarih',en:'Previous date'},
  'Alte Bemerkung':{tr:'Önceki açıklama',en:'Previous comment'},
  'Mahneintrag löschen?':{tr:'Ödeme hatırlatması silinsin mi?',en:'Delete payment reminder?'},
  'Brief erstellen / Drucken – zurückgestellt':{tr:'Mektup oluşturma / Yazdırma – sonraki aşamada',en:'Create letter / Print – deferred'},
  'Betreff':{tr:'Konu',en:'Subject'},
  'Gedruckt':{tr:'Yazdırıldı',en:'Printed'},
  'Karte öffnen':{tr:'Kartı aç',en:'Open card'},
};
